import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Custom preloading strategy for Angular lazy-loaded modules.
 * Only preloads routes explicitly marked with data: { preload: true }.
 * Improves initial performance without loading all modules at app startup.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  /**
   * Determines if a route should be preloaded.
   * @param route Route configuration to evaluate
   * @param fn Function that performs lazy-loaded module preloading
   * @returns Observable that completes preloading or null if should not preload
   */
  preload(route: Route, fn: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload']) {
      return fn();
    }
    return of(null);
  }
}
